!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.az = t());
}(this, function () {
  "use strict";

  return [{
    locale: "az",
    pluralRuleFunction: function (e, t) {
      var a = String(e).split(".")[0],
        r = a.slice(-1),
        i = a.slice(-2),
        o = a.slice(-3);
      return t ? 1 == r || 2 == r || 5 == r || 7 == r || 8 == r || 20 == i || 50 == i || 70 == i || 80 == i ? "one" : 3 == r || 4 == r || 100 == o || 200 == o || 300 == o || 400 == o || 500 == o || 600 == o || 700 == o || 800 == o || 900 == o ? "few" : 0 == a || 6 == r || 40 == i || 60 == i || 90 == i ? "many" : "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "İl",
        relative: {
          0: "bu il",
          1: "gələn il",
          "-1": "keçən il"
        },
        relativeTime: {
          future: {
            one: "{0} il ərzində",
            other: "{0} il ərzində"
          },
          past: {
            one: "{0} il öncə",
            other: "{0} il öncə"
          }
        }
      },
      "year-short": {
        displayName: "il",
        relative: {
          0: "bu il",
          1: "gələn il",
          "-1": "keçən il"
        },
        relativeTime: {
          future: {
            one: "{0} il ərzində",
            other: "{0} il ərzində"
          },
          past: {
            one: "{0} il öncə",
            other: "{0} il öncə"
          }
        }
      },
      month: {
        displayName: "Ay",
        relative: {
          0: "bu ay",
          1: "gələn ay",
          "-1": "keçən ay"
        },
        relativeTime: {
          future: {
            one: "{0} ay ərzində",
            other: "{0} ay ərzində"
          },
          past: {
            one: "{0} ay öncə",
            other: "{0} ay öncə"
          }
        }
      },
      "month-short": {
        displayName: "ay",
        relative: {
          0: "bu ay",
          1: "gələn ay",
          "-1": "keçən ay"
        },
        relativeTime: {
          future: {
            one: "{0} ay ərzində",
            other: "{0} ay ərzində"
          },
          past: {
            one: "{0} ay öncə",
            other: "{0} ay öncə"
          }
        }
      },
      day: {
        displayName: "Gün",
        relative: {
          0: "bu gün",
          1: "sabah",
          "-1": "dünən"
        },
        relativeTime: {
          future: {
            one: "{0} gün ərzində",
            other: "{0} gün ərzində"
          },
          past: {
            one: "{0} gün öncə",
            other: "{0} gün öncə"
          }
        }
      },
      "day-short": {
        displayName: "Gün",
        relative: {
          0: "bu gün",
          1: "sabah",
          "-1": "dünən"
        },
        relativeTime: {
          future: {
            one: "{0} gün ərzində",
            other: "{0} gün ərzində"
          },
          past: {
            one: "{0} gün öncə",
            other: "{0} gün öncə"
          }
        }
      },
      hour: {
        displayName: "Saat",
        relative: {
          0: "bu saat"
        },
        relativeTime: {
          future: {
            one: "{0} saat ərzində",
            other: "{0} saat ərzində"
          },
          past: {
            one: "{0} saat öncə",
            other: "{0} saat öncə"
          }
        }
      },
      "hour-short": {
        displayName: "saat",
        relative: {
          0: "bu saat"
        },
        relativeTime: {
          future: {
            one: "{0} saat ərzində",
            other: "{0} saat ərzində"
          },
          past: {
            one: "{0} saat öncə",
            other: "{0} saat öncə"
          }
        }
      },
      minute: {
        displayName: "Dəqiqə",
        relative: {
          0: "bu dəqiqə"
        },
        relativeTime: {
          future: {
            one: "{0} dəqiqə ərzində",
            other: "{0} dəqiqə ərzində"
          },
          past: {
            one: "{0} dəqiqə öncə",
            other: "{0} dəqiqə öncə"
          }
        }
      },
      "minute-short": {
        displayName: "dəq.",
        relative: {
          0: "bu dəqiqə"
        },
        relativeTime: {
          future: {
            one: "{0} dəqiqə ərzində",
            other: "{0} dəqiqə ərzində"
          },
          past: {
            one: "{0} dəqiqə öncə",
            other: "{0} dəqiqə öncə"
          }
        }
      },
      second: {
        displayName: "Saniyə",
        relative: {
          0: "indi"
        },
        relativeTime: {
          future: {
            one: "{0} saniyə ərzində",
            other: "{0} saniyə ərzində"
          },
          past: {
            one: "{0} saniyə öncə",
            other: "{0} saniyə öncə"
          }
        }
      },
      "second-short": {
        displayName: "san.",
        relative: {
          0: "indi"
        },
        relativeTime: {
          future: {
            one: "{0} saniyə ərzində",
            other: "{0} saniyə ərzində"
          },
          past: {
            one: "{0} saniyə öncə",
            other: "{0} saniyə öncə"
          }
        }
      }
    }
  }, {
    locale: "az-Arab",
    pluralRuleFunction: function (e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "Year",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      "year-short": {
        displayName: "Year",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      month: {
        displayName: "Month",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      "month-short": {
        displayName: "Month",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      day: {
        displayName: "Day",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      "day-short": {
        displayName: "Day",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      hour: {
        displayName: "Hour",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      "hour-short": {
        displayName: "Hour",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      minute: {
        displayName: "Minute",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      "minute-short": {
        displayName: "Minute",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      second: {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      },
      "second-short": {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      }
    }
  }, {
    locale: "az-Cyrl",
    pluralRuleFunction: function (e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "Year",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      "year-short": {
        displayName: "Year",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "+{0} y"
          },
          past: {
            other: "-{0} y"
          }
        }
      },
      month: {
        displayName: "Month",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      "month-short": {
        displayName: "Month",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "+{0} m"
          },
          past: {
            other: "-{0} m"
          }
        }
      },
      day: {
        displayName: "Day",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      "day-short": {
        displayName: "Day",
        relative: {
          0: "today",
          1: "tomorrow",
          "-1": "yesterday"
        },
        relativeTime: {
          future: {
            other: "+{0} d"
          },
          past: {
            other: "-{0} d"
          }
        }
      },
      hour: {
        displayName: "Hour",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      "hour-short": {
        displayName: "Hour",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "+{0} h"
          },
          past: {
            other: "-{0} h"
          }
        }
      },
      minute: {
        displayName: "Minute",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      "minute-short": {
        displayName: "Minute",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "+{0} min"
          },
          past: {
            other: "-{0} min"
          }
        }
      },
      second: {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      },
      "second-short": {
        displayName: "Second",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "+{0} s"
          },
          past: {
            other: "-{0} s"
          }
        }
      }
    }
  }, {
    locale: "az-Latn",
    parentLocale: "az"
  }];
});